import React from 'react';
import './TestBubbles.css';

const bubbles = Array.from({ length: 500 }, (_, i) => {
  const size = Math.floor(Math.random() * 16) + 6;
  const left = Math.random() * 100;
  const delay = Math.random() * 18;
  const color = [
    'rgba(255,255,255,0.7)',
    'rgba(0,246,255,0.7)',
    'rgba(74,124,255,0.7)',
    'rgba(255,153,0,0.7)',
    'rgba(234,242,255,0.6)',
    'rgba(0,0,0,0.4)'
  ][i % 6];
  return (
    <div
      key={i}
      className="bubble"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        left: `${left}%`,
        top: '100%',
        background: 'transparent',
        boxShadow: `0 0 ${size * 2}px ${color}, 0 0 ${size * 3}px ${color}`,
        border: `2px solid ${color}`,
        animationDelay: `${delay}s`
      }}
    />
  );
});

const TestBubblesCSS = ({ hideText }) => (
  <div className="bubbles-bg">
    {bubbles}
    {!hideText && (
      <div style={{position: 'relative', zIndex: 2, marginTop: '120px', textAlign: 'center'}}>
        <h1>Test Bubbles CSS/SVG</h1>
        <p>Questa è una pagina di test con bolle animate solo CSS.</p>
      </div>
    )}
  </div>
);

export default TestBubblesCSS;
